import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar ,useGridApiRef} from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import FolderIcon from "@mui/icons-material/Folder";
import HouseIcon from "@mui/icons-material/House";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import GridOnIcon from "@mui/icons-material/GridOn";
import DownloadIcon from "@mui/icons-material/Download";
import CollapseSection from "../../components/ui/CollapseSection";
import DeleteIcon from "@mui/icons-material/Delete";
import StorageIcon from "@mui/icons-material/Storage";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import SharedComponent from "./SharedComponent";
import Alert from "../../components/ui/Alert";
import {
  GetUserCountries,
  GetFolderIdByName,
  GetFolderContent,
  DownloadFile,
  DeleteFile,
  UploadFile,
  ProcessFile,
  setState,
  clearStatus,
  UploadRepositoryFile,
  GetRepositoryFiles,
  DownloadRepositoryFile,
  DeleteRepositoryFile
} from "./fileTransferSlice";
import moment from "moment";
import CustomButton from "../../components/ui/CustomButton";
import CustomLoadingScreen from "../../components/ui/CustomLoadingScreen";
import MessageSnackbar from "../../components/ui/MessageSnackbar";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import ImageIcon from "@mui/icons-material/Image";
import FolderZipIcon from "@mui/icons-material/FolderZip";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function FileInterface() {
  const apiRef = useGridApiRef();
  const autherization = localStorage.getItem("data");
  const mydata = JSON.parse(autherization);
  let setAccess = true;
  if (mydata?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const homeFolderName = "";
  const dispatch = useDispatch();
  var data = require("../../assets/MoveitConfig.json");
  const fileTransfer = useSelector((state) => state.fileTransfer);
  const {
    countries,
    getFolderIdByName,
    getFolderContent,
    isLoading,
    isAlert,
    isAlert_Info,
  } = fileTransfer;

  const [dataGridContent, setdataGridContent] = useState([]);
  const [breadcrumb, setBreadcrumb] = useState("");
  const [parentFolderList, setParentFolderList] = useState("");
  const [selectedFolderID, setSelectedFolderID] = useState("");
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    notfound: false,
  });

  const [isFileAvailable, setIsFileAvailable] = useState(false);
  const [showSearchField, setShowSearchField] = useState(false);
  const [fileToProcess, setFileToProcess] = useState("");
  const [parentFileID, setParentFileID] = useState("");
  const [open, setOpen] = React.useState(false);
  const [openProcessDialog, setOpenProcessDialog] = React.useState(false);

  let isCountryFolder = false;
  let sortableField = "name";
  const [isProcessButton, setIsProcessButton] = useState(false);
  const [isDeleteButton, setIsDeleteButton] = useState(false);
 //State for Repository File Deletion
  const [fileToDelete, setFileToDelete] = useState("");

  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });

  const moveitDeleteConfig = data["DeleteInclude"];
  const moveitProcessConfig = data["ProcessInclude"];
  const moveitCountryFolders = data["CountryFolders"];

  const displayAlert = (showAlert, alertMessage) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: `${showAlert}`,
      alertMessage: `${alertMessage}`,
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleProcessClickOpen = () => {
    setOpenProcessDialog(true);
  };

  const handleProcessClickClose = () => {
    setOpenProcessDialog(false);
  };

  useEffect(() => {
    //if (countries.length <= 0) {
      dispatch(GetUserCountries({ method: "Get" }));
      return () => {
        dispatch(setState("isAlert", false));
        dispatch(setState("isAlert_Info", ""));
        dispatch(clearStatus());
      };
    //}
  }, []);

  useEffect(() => {
    let obj = {
      FolderName: "",
    };
    dispatch(GetFolderIdByName(obj));
  }, [homeFolderName]);

  useEffect(() => {
    let obj = {
      method: "GET",
      id: getFolderIdByName,
    };

    setParentFolderList(getFolderIdByName);
    dispatch(GetFolderContent(obj));
  }, [getFolderIdByName]);

  useEffect(() => {
    //console.log("The folder content is::::", getFolderContent);
    let folderItemsArr = getFolderContent;

    if (breadcrumb == "") {
      folderItemsArr = getFolderContent.filter(
        (item) => item.name == "Archive" ||
                  item.name == "Inbound" ||
                  item.name == "Outbound" ||
                  item.name == "Repository"
      );
    }
    if (breadcrumb === "/Repository") {
      // Prioritize Global folder at the top being common accross all countries
      const globalFolder = folderItemsArr.find((item) => item.name === "Global");
      const otherFolders = folderItemsArr.filter(
        (item) =>
           item.name !== "Global" && 
           countries.some((country)=>country.countryName === item.name)
      );
      folderItemsArr = globalFolder ? [globalFolder, ...otherFolders] : otherFolders;
    }
    if (breadcrumb.startsWith("/Repository/")) {
      setIsFileAvailable(true);

      setShowSearchField(true);
    }

    // if (breadcrumb == "/Inbound") {
    //   folderItemsArr = getFolderContent.filter(
    //     (item) =>
    //       item.name == "External Fix" ||
    //       item.name == "France" ||
    //       item.name == "Local" ||
    //       item.name == "Data Mapping"
    //   );
    // }

    if (breadcrumb === "/Inbound") {
      folderItemsArr = getFolderContent.filter((item) => {
        const isFranceVisible = countries.some(
          (country) => country.countryName.toLowerCase() === "france"
        );
    
        return (
          item.name === "External Fix" ||
          item.name === "Local" ||
          item.name === "Data Mapping" ||
          (item.name === "France" && isFranceVisible)
        );
      });
    }
    if (getFolderContent.length > 0) {
      let isFileStatusArray = getFolderContent.map(
        (item) => item.type === "File"
      );
      //console.log("breadcrumb", breadcrumb);
      let isFile = isFileStatusArray.indexOf(true) > -1;
      if (
        isFile &&
        (breadcrumb.toLocaleLowerCase().includes("external fix") ||
          breadcrumb.toLocaleLowerCase().includes("france") ||
          breadcrumb.toLocaleLowerCase().includes("local") ||
          breadcrumb.toLocaleLowerCase().includes("data mapping")
          
          )
      ) {
        //console.log("isFile", isFile);
        setIsFileAvailable(true);
      } else {
        setIsFileAvailable(false);
      }

      if (
        isFile &&
        (breadcrumb.toLocaleLowerCase().includes("external fix") ||
          breadcrumb.toLocaleLowerCase().includes("france") ||
          breadcrumb.toLocaleLowerCase().includes("local") ||
          breadcrumb.toLocaleLowerCase().includes("data mapping") ||
          breadcrumb.toLocaleLowerCase().includes("processed") ||
          breadcrumb.toLocaleLowerCase().includes("rejected") ||
          breadcrumb.toLocaleLowerCase().includes("quota definition") ||
          breadcrumb.toLocaleLowerCase().includes("quota modification definition")
          
          )
      ) {
        //console.log("isFile", isFile);
        setShowSearchField(true);
      } else {
        setShowSearchField(false);
      }

      isCountryFolder = false;
      for (let i = 0; i < moveitCountryFolders.length; i++) {
        if (breadcrumb.toLowerCase() == moveitCountryFolders[i].toLowerCase()) {
          // setIsCountryFolder(true);
          isCountryFolder = true;
          break;
        }
      }

      for (let i = 0; i < moveitProcessConfig.length; i++) {
        if (breadcrumb.toLowerCase() == moveitProcessConfig[i].toLowerCase()) {
          setIsProcessButton(true);
          break;
        }
      }

      for (let i = 0; i < moveitDeleteConfig.length; i++) {
        if (breadcrumb.toLowerCase() == moveitDeleteConfig[i].toLowerCase()) {
          setIsDeleteButton(true);
          break;
        }
      }

      if (
        breadcrumb == "/Inbound/External Fix" ||
        breadcrumb == "/Inbound/France" ||
        breadcrumb == "/Inbound/Local"
      ) {
        if (isCountryFolder) {
          // If folder with country folders show only required country folders
          folderItemsArr = getFolderContent.filter((item) =>
            countries.some(
              (country) =>
                country.countryName.toLowerCase() === item.name.toLowerCase()
            )
          );
        } else {
          folderItemsArr = getFolderContent;
        }
      }

      if (
        breadcrumb == "/Inbound/External Fix" ||
        breadcrumb == "/Inbound/Local/Market Data" ||
         breadcrumb == "/Inbound/Local/SIT" ||
          breadcrumb == "/Outbound/Quota Definition" || 
           breadcrumb == "/Outbound/Quota Modification Definition"
      ) {
          folderItemsArr = getFolderContent.filter((item) =>
            countries.some(
              (country) =>
                country.countryName.toLowerCase() === item.name.toLowerCase()
            )
          );
      }
      //console.log("folderItemsArr", folderItemsArr);
      setdataGridContent(folderItemsArr);
    } else if(!breadcrumb.startsWith("/Repository/")) {
      setdataGridContent([]);
    }
  }, [getFolderContent]);

  function handleParentFolder() {
    apiRef.current.setQuickFilterValues([]);
    let obj = {
      method: "GET",
      id: getFolderIdByName,
    };

    dispatch(GetFolderContent(obj));

    setColumnVisibilityModel({ notfound: false });
    setBreadcrumb("");
  }

  function handleChildFolder() {
    apiRef.current.setQuickFilterValues([]);
    let selectedFolderID = getFolderIdByName;
    const withoutLastBreadcrumb = breadcrumb.slice(
      0,
      breadcrumb.lastIndexOf("/")
    );

    setBreadcrumb(withoutLastBreadcrumb);

    const withoutLastId = parentFolderList.slice(
      0,
      parentFolderList.lastIndexOf(",")
    );

    setParentFolderList(withoutLastId);
    const myarray = withoutLastId.split(",");

    selectedFolderID = myarray[myarray.length - 1];

    let obj = {
      method: "GET",
      id: selectedFolderID,
    };

    dispatch(GetFolderContent(obj));

    if (selectedFolderID == getFolderIdByName) {
      setColumnVisibilityModel({ notfound: false });
    }
  }

  function setRowSelectionModel(params) {
    let id = params.row.id;
    let field = params.field;
    let type = params.row.type;
    let fileName = params.row.name;
    let parentIdToRefresh = params.row.parentId;

    setParentFileID(parentIdToRefresh);
    setFileToProcess(id);
    setFileToDelete(fileName); //Store file name for repository file deletion

    if (field == "name" && type == "Folder") {
      if (id) {
        const selectedRowsData = getFolderContent.find((row) => row.id === id);
        let name = breadcrumb + "/" + selectedRowsData["name"];
        let parentId = parentFolderList + "," + id;
        setBreadcrumb(name);
        setParentFolderList(parentId);
        setColumnVisibilityModel({ notfound: true });

        setSelectedFolderID(id);

        let obj = {
          method: "GET",
          id: id,
        };

        dispatch(GetFolderContent(obj));
        sortableField = "name";
      }
    }

    if (field == "path" && type == "File") {
      if(breadcrumb.startsWith("/Repository/")){
        dispatch(DownloadRepositoryFile(fileName));
      }
      else{
        let obj = {
          method: "GET",
          fileId: id,
          fileName: fileName,
        };
  
        dispatch(DownloadFile(obj));
      }

      sortableField = "lastUpdateTime";
    }

    // if (
    //   field == "delete" &&
    //   type == "File" &&
    //   !fileName.toLowerCase().endsWith("_template.xlsx")
    // ) {
    //   handleClickOpen();
    // }

    // if (
    //   field == "process" &&
    //   type == "File" &&
    //   !fileName.toLowerCase().endsWith("_template.xlsx")
    // ) {
    //   handleProcessClickOpen();
    // }
  }

  function handleDeleteFile() {

      if (breadcrumb.startsWith("/Repository/")) {
        let selectedCountryID = 0;
        const breadcrumbParts = breadcrumb.split("/");

        if (breadcrumbParts.length > 2) {
          const lastEntry = breadcrumbParts[breadcrumbParts.length - 1];
            const matchedCountry = countries.find(
                (country) => country.countryName.toLowerCase() === lastEntry.toLowerCase()
            );

            if (matchedCountry) {
                selectedCountryID = matchedCountry.countryID;
            }
        }

        dispatch(DeleteRepositoryFile(fileToDelete))
            .then((response) => {
              if (response?.error) {
                console.error("Failed to delete repository file:", response.error);
                return;
              }
              //console.log("Repository file deleted successfully.");

             //Fetch updated file list after delete success
            return dispatch(GetRepositoryFiles(selectedCountryID));
            })
            .then((updatedResponse) => {
              if (updatedResponse?.payload) {
                const transformedData = updatedResponse.payload.map((file) => ({
                  id: file.fileID, 
                  name: file.fileName, 
                  type: "File", // Mark it as a file type
                  path: file.fileID, 
                  delete: file.fileID, 
                }));
        
                setdataGridContent(transformedData);
                //console.log("DataGrid updated with latest files.");
              }
            })
            .catch((error) => {
              console.error("Error during file delete or refresh:", error);
            })
            .finally(()=>{
              handleClose();
            });
    }
    else{
      handleClose();
      let obj = {
        fileId: fileToProcess,
      };
  
      dispatch(DeleteFile(obj))
        //.then(() => handleClose())
        .then(() => GetFolderContentAfterProcessing(selectedFolderID));
    }
  }

  function handleProcessFile() {
    handleProcessClickClose();
    let obj = {
      fileId: fileToProcess,
      filePath: breadcrumb,
    };

    dispatch(ProcessFile(obj))
      //.then(() => handleProcessClickClose())
      .then(() => GetFolderContentAfterProcessing(selectedFolderID));
  }

  function GetFolderContentAfterProcessing(fileId) {
    let obj = {
      method: "GET",
      id: fileId,
    };

    dispatch(GetFolderContent(obj));
    sortableField = "lastUpdateTime";
  }

  const handleFileUpload = (event) => {
    const fileObj = event.target.files[0];

    for (let i = 0; i < getFolderContent.length; i++) {
      if (getFolderContent[i].name == fileObj.name) {
        displayAlert(true, "File already exists");
        return;
      }
    }

    var today = new Date();
    var thisYear = today.getFullYear();
    var thisMonth = ("0" + (today.getMonth() + 1)).slice(-2);
    var thisDay = ("0" + today.getDate()).slice(-2);
    var now =
      today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds();

    let fileName =
      fileObj.name.replace(/\.[^/.]+$/, "") +
      "_" +
      thisYear +
      thisMonth +
      thisDay +
      "_" +
      now;

    let fileExtension = fileObj.name.split(".").pop();

    var obj = {
      filePath: breadcrumb,
      folderId: selectedFolderID,
      fileExtension: fileExtension,
      fileName: fileName,
      type: fileObj.type,
      fileObj: fileObj,
    };

    dispatch(UploadFile(obj))
      .then(() => GetFolderContentAfterProcessing(selectedFolderID))
      //.then(() => DisplayAlertMessage());

    event.target.value = "";
    event.target.files = null;
  };

  useEffect(() => {
    if (breadcrumb.startsWith("/Repository")) {
      setColumnVisibilityModel((prev) => ({
        ...prev,
        lastUpdateTime: false, // Hide "Last Modified On"
        size: false, // Hide "Size"
        process: false, // Hide "Process"
      }));
    } else {
      setColumnVisibilityModel((prev) => ({
        ...prev,
        lastUpdateTime: true,
        size: true,
        process: true,
      }));
    }
  }, [breadcrumb]);



  useEffect(() => {
    if (breadcrumb.startsWith("/Repository/")) {
      let selectedCountryID = 0;
      const breadcrumbParts = breadcrumb.split("/");
      const lastEntry = breadcrumbParts[breadcrumbParts.length - 1];
  
      const matchedCountry = countries.find(
        (country) => country.countryName.toLowerCase() === lastEntry.toLowerCase()
      );
  
      if (matchedCountry) {
        selectedCountryID = matchedCountry.countryID;
      }
  
      //console.log("Fetching repository files for GeoID:", selectedCountryID);
  
     // if (selectedCountryID !== 0) {
        dispatch(GetRepositoryFiles(selectedCountryID)).then((response) => {
          if (response?.payload) {
            const transformedData = response.payload.map((file) => ({
              id: file.fileID, 
              name: file.fileName,
              type: "File", // Mark it as a file type
              path: file.fileID, 
              delete: file.fileID,
            }));
            setdataGridContent(transformedData);
          }
        });
      //}
    }
  }, [breadcrumb, countries, dispatch]);


  function DisplayAlertMessage() {
    if (isAlert) displayAlert(true, isAlert_Info);
  }

  const columns = [
    {
      field: "notfound",
      sortable: false,
      renderHeader: () => (
        <div>
          <HouseIcon
            fontSize="large"
            onClick={handleParentFolder}
            sx={{ color: "darkBlue.light", cursor: "pointer" ,mt: 3 }}
          />
          <KeyboardReturnIcon
            fontSize="large"
            onClick={handleChildFolder}
            sx={{
              color: "darkBlue.light",
              cursor: "pointer",
              transform: "rotate(90deg)",
              mt:3
            }}
          />
        </div>
      ),
      flex: 1.5,
    },
    {
      field: "name",
      headerName: "Name",
      flex: 4,
      renderCell: (params) => {
        let name = params.row.name;
        if (params.row.type == "Folder") {
          return (
            <div style={{ cursor: "pointer" }}>
              <FolderIcon
                sx={{
                  color: "#f8d775",
                  cursor: "pointer",
                  transform: "translate(0px, 5px)",
                  mr: 1,
                }}
                className="folderIcon"
              />
              <span className="spanCursor">{params.row.name}</span>
            </div>
          );
        } else {
          if (name.toLowerCase().includes(".zip") || name.toLowerCase().includes(".rar")) {
            return (
              <div>
                <FolderZipIcon sx={{ color: "blue.main" }} />
                <span>{params.row.name}</span>
              </div>
            );
          } else if (name.toLowerCase().includes(".xls") || name.toLowerCase().includes(".csv")) {
            return (
              <div>
                <GridOnIcon sx={{ color: "green.main" }} />
                <span>{params.row.name}</span>
              </div>
            );
          } 
          else if (name.toLowerCase().includes(".txt")) {
            return (
              <div>
               <DescriptionIcon sx={{ color: "brown.main" }} />
                <span>{params.row.name}</span>
              </div>
            );
          } 
          else if (name.toLowerCase().includes(".png") || name.toLowerCase().includes(".jpg") || name.toLowerCase().includes(".jpeg")) {
            return (
              <div>
               <ImageIcon sx={{ color: "orange.main" }} />
                <span>{params.row.name}</span>
              </div>
            );
          }
          else if (name.toLowerCase().includes(".pdf")) {
            return (
              <div>
                <PictureAsPdfIcon sx={{ color: "red.main" }} />
                <span>{params.row.name}</span>
              </div>
            );
          } 
          else {
            <span>{params.row.name}</span>;
          }
        }
      },
    },
    // {
    //   field: "lastUpdateTime",
    //   headerName: "Last Modified on",
    //   flex: 2,
    //   renderCell: (params) => {
    //     let lastUpdateTime = new Date(params.row.lastUpdateTime);
    //     lastUpdateTime = moment(lastUpdateTime).format("DD/MM/yyyy, h:mm:ss A");
    //     if (params.row.type == "File") {
    //       return <span>{lastUpdateTime}</span>;
    //     } else return <span></span>;
    //   },
    //   clickable: false,
    // },
    {
      field: "lastUpdateTime",
      headerName: "Last Modified on",
      type: "date",
      flex: 2,
      valueGetter: (params) => {
        const rawValue = params.row.lastUpdateTime;
        return rawValue ? new Date(rawValue) : null;
      },
      renderCell: (params) => {
        const { value } = params;
        if (!value || params.row.type !== "File") {
          return <span>-</span>; // or leave it blank: <span></span>
        }
        const formattedTime = moment(value).format("DD/MM/yyyy, h:mm:ss A");
        return <span>{formattedTime}</span>;
      },
      clickable: false,
    },    
    {
      field: "size",
      headerName: "Size",
      flex: 1,
      renderCell: (params) => {
        if (params.row.type == "File") {
          return <span>{params.row.size}</span>;
        } else return <span></span>;
      },
      clickable: false,
      sortable: false,
    },
    {
      field: "path",
      headerName: "Download",
      flex: 1,
      renderCell: (params) => {
        if (params.row.type == "File") {
          return (
            <div>
              <DownloadIcon sx={{ cursor: "pointer", color: "green.main" }} />
            </div>
          );
        } else return <span></span>;
      },
      clickable: false,
      sortable: false,
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 1,
      renderCell: (params) => {
        if (
          params.row.type == "File" &&
          !params.row.name.toLowerCase().endsWith("_template.xlsx") &&
          //isDeleteButton &&
          isFileAvailable &&
          isRestrictedAccess
        ) {
          return (
            <div>
              <DeleteIcon
                sx={{ color: "red.main", cursor: "pointer" }}
                onClick={handleClickOpen}
              />
            </div>
          );
        } else return <span></span>;
      },
      clickable: false,
      sortable: false,
    },
    {
      field: "process",
      headerName: "Process",
      flex: 1,
      renderCell: (params) => {
        if (
          params.row.type == "File" &&
          !params.row.name.toLowerCase().endsWith("_template.xlsx") &&
          //isProcessButton &&
          isFileAvailable &&
          isRestrictedAccess
        ) {
          return (
            <div>
              <StorageIcon
                sx={{ color: "rgb(98, 0, 255)", cursor: "pointer" }}
                onClick={handleProcessClickOpen}
              />
            </div>
          );
        } else return <span></span>;
      },
      clickable: false,
      sortable: false,
    },
  ];

  const handleCloseSnackbar=()=>{
    clearAlert();
  }
  const clearAlert = () => {
    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: ``,
    });
  };
  
  const handleRepositoryFileUpload = async (event) => {
    const files = event.target.files;
    if (!files.length) return;
  
    let selectedCountryID = 0;
    const breadcrumbParts = breadcrumb.split("/");
  
    if (breadcrumbParts.length > 2) {
      const lastEntry = breadcrumbParts[breadcrumbParts.length - 1];
  
      const matchedCountry = countries.find(
        (country) => country.countryName.toLowerCase() === lastEntry.toLowerCase()
      );
  
      if (matchedCountry) {
        selectedCountryID = matchedCountry.countryID;
      }
    }
  
    //console.log("Selected Country ID:", selectedCountryID);
  
    //Get current timestamp
    const today = new Date();
    const thisYear = today.getFullYear();
    const thisMonth = ("0" + (today.getMonth() + 1)).slice(-2);
    const thisDay = ("0" + today.getDate()).slice(-2);
    const now =
      today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds();
  
    //Append timestamp to filenames
    const fileObjects = Array.from(files).map((file) => {
      let fileExtension = file.name.split(".").pop();
      let fileName =
        file.name.replace(/\.[^/.]+$/, "") +
        "_" +
        thisYear +
        thisMonth +
        thisDay +
        "_" +
        now +
        "." +
        fileExtension;
  
      return new File([file], fileName, { type: file.type });
    });
  
    //console.log("Files with updated names:", fileObjects.map((f) => f.name));
  
    const uploadPayload = {
      geoID: selectedCountryID,
      files: fileObjects,
    };
  
    //Upload files & wait for completion
    dispatch(UploadRepositoryFile(uploadPayload))
      .then((response) => {
        if (response?.error) {
          console.error("Upload failed:", response.error);
          return;
        }
        //console.log("Upload successful! Fetching updated file list...");
  
        //Fetch updated file list after upload success
        return dispatch(GetRepositoryFiles(selectedCountryID));
      })
      .then((updatedResponse) => {
        if (updatedResponse?.payload) {
          const transformedData = updatedResponse.payload.map((file) => ({
            id: file.fileID,
            name: file.fileName, 
            type: "File", // Mark it as a file type
            path: file.fileID, 
            delete: file.fileID, 
          }));
  
          setdataGridContent(transformedData);
          //console.log("DataGrid updated with latest files.");
        }
      })
      .catch((error) => {
        console.error("Error during file upload or refresh:", error);
      });
  
    //Reset file input
    event.target.value = "";
    event.target.files = null;
  };
  
  return (
    <Box mt={3}>
    <CollapseSection title="File Upload & Download">
      <Box mt={3}>
        <Box mt={2}>
          <h5 sx={{ color: "007dc3" }}>Path:{breadcrumb}</h5>
        </Box>
          {isFileAvailable && breadcrumb.startsWith("/Repository/") && (
          <CustomButton
            component="label"
            role={undefined}
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
            disabled={!isRestrictedAccess}
          >
            Upload file
            <VisuallyHiddenInput
              type="file"
              multiple
              onChange={handleRepositoryFileUpload}
            />
          </CustomButton>
        )}

        {isFileAvailable && !breadcrumb.startsWith("/Repository/") && (
          <CustomButton
            component="label"
            role={undefined}
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
            disabled={!isRestrictedAccess}
            onChangeCapture={handleFileUpload}
          >
            Upload file
            <VisuallyHiddenInput
              type="file"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            />
          </CustomButton>
        )}

        {alert.alertDisplay && (
            <MessageSnackbar
            message={alert.alertMessage}
            severity={alert.alertSeverity}
            open={alert.alertDisplay}
            onClose={handleCloseSnackbar}
          />
        )}
        <CustomLoadingScreen isLoading={isLoading} />
        <SharedComponent />
        <Box mt={2} sx={{ width: "100%" }}>
          <DataGrid
           apiRef={apiRef}
            disableColumnMenu
            rows={dataGridContent || []}
            columns={columns}
            sx={{
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "grey.lighter",
                color: "black.main",
                fontWeight: "bold",
                fontSize: "16px",
                height: "50px",
                lineHeight: "50px",
                border: "1px solid #c6c6c6",
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
              },
            }}
            getRowId={(row) => row?.id}
            initialState={{
              filter: {
                filterModel: {
                  items: ["name"],
                  quickFilterValues: [],
                },
              },
              sorting: {
                sortModel: [{ field: { sortableField }, sort: "desc" }],
              },
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20, 50, 100]}
            onCellClick={setRowSelectionModel}
            hideFooterSelectedRowCount
            columnVisibilityModel={columnVisibilityModel}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: showSearchField,
                quickFilterProps: {
                  variant: "outlined",
                  size: "small",
                },
                printOptions: { disableToolbarButton: true },
                csvOptions: { disableToolbarButton: true },
              },
            }}
          />
        </Box>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to delete the file?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CustomButton onClick={handleClose}>No</CustomButton>
          <CustomButton onClick={handleDeleteFile} autoFocus>
            Yes
          </CustomButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openProcessDialog}
        onClose={handleProcessClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to process the file?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CustomButton onClick={handleProcessClickClose}>No</CustomButton>
          <CustomButton  onClick={handleProcessFile} autoFocus>Yes</CustomButton>
        </DialogActions>
      </Dialog>
    </CollapseSection>
    </Box>
  );
}
